import styled from 'styled-components';

export const SectionHeading = styled.h2`
  color: ${Styles.color.grey.one};
  font-family: ${Styles.fontFamily.base};
  margin-block-start: 0;
  margin-block-end: 0.625rem;
  margin-inline: 0;
  text-transform: uppercase;
`;
